
import { useEffect, useState } from "react";
import Sider from "../../comps/sider/main";
import './main.css';
import { Link, useSearchParams } from 'react-router-dom';
import callAPI from "../../comps/fetch/main";
import ShowPlans from "../../comps/show_plans/main";
import { Alert, Progress, Radio, Input, Skeleton, Carousel, List, Card, message, Col, Row, Statistic, Tooltip, Empty, Button, Collapse, Popover, Divider, Modal, Segmented, Tag, Space, Tabs, Select, FloatButton, Flex, Form, Steps, Checkbox, Rate } from "antd";
import { RightCircleOutlined, VideoCameraOutlined, HistoryOutlined, PlusSquareOutlined, PlusCircleOutlined, StepForwardOutlined, FastForwardOutlined, BranchesOutlined, FilterOutlined, FilterTwoTone, InstagramOutlined, YoutubeOutlined, CommentOutlined, MessageOutlined, AndroidOutlined, UsergroupAddOutlined, AppleOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from "react-router-dom";
import AccessOrNot from "../../funcs/accessOrNot";
import AutomationList from "../automationList/main";
import WhatsNew from "../../comps/whatsNew/main";
import IGPosts from "../../comps/list-ig-posts/main";
import NewYearSaleBanner from "../../comps/newYearSaleBanner/main";
import PongalSankrantiBanner from "../../comps/pongalBanner/main";

import HomeDashboard from "../../comps/home-dashboard/main";
import confetti from "canvas-confetti";
import { fireDB } from "../../funcs/firebase";
import { getDocs, collection, doc, getDoc, setDoc, deleteDoc, serverTimestamp } from "firebase/firestore";

const { Step } = Steps;
function WelcomePopup({ PlanData }) {
  const [open, setOpen] = useState();
  const [current, setCurrent] = useState(0);
  const [userData, setUserData] = useState(JSON.parse(localStorage.getItem("userData")))
  const [form] = Form.useForm();
  const [thankYou, setThankYou] = useState(false)

  const [selectedRating, setSelectedRating] = useState("");
  const [selectedFeatures, setSelectedFeatures] = useState([]);
  const isGoodRating = ["perfect", "good", "average"].includes(selectedRating?.toLowerCase());
  const wantsAI = selectedFeatures.includes("ai_automation");
  let survery_collection = "survey-testimonial-dec-2025"

  const steps = [
    {
      id: "rating",
      title: "Rating",
      fields: ["rating"],
      content: (
        <>
          <Alert
            message="🚀 Big Update!"
            description="IOS and Android App (Launching Jan 2026)"
            type="info"
            showIcon
            style={{ marginBottom: 16 }}
          />
          <Form.Item
            label="How would you rate your experience with InstantDM?"
            name="rating"
            rules={[{ required: true, message: "Please select a rating" }]}
          >
            <Radio.Group
              onChange={(e) => setSelectedRating(e.target.value)}
              style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '12px' }}
            >
              <Radio className="survey-radio-option" value="perfect">Perfect</Radio>
              <Radio className="survey-radio-option" value="good">Good</Radio>
              <Radio className="survey-radio-option" value="average">Average</Radio>
              <Radio className="survey-radio-option" value="poor">Poor</Radio>
              <Radio className="survey-radio-option" value="very_poor">Very poor</Radio>
            </Radio.Group>
          </Form.Item>
        </>
      ),
    },
    {
      id: "feedback",
      title: isGoodRating ? "Testimonial" : "Share your issue",
      fields: [isGoodRating ? "testimonial" : "issue_detail"],
      content: isGoodRating ? (
        <Form.Item
          label="We'd love to hear your thoughts! Any testimonial or feedback?"
          name="testimonial"
          rules={[{ required: true, message: "Please share your thoughts" }]}
        >
          <Input.TextArea rows={4} placeholder="Your feedback helps us improve..." />
        </Form.Item>
      ) : (
        <Form.Item
          label="Share your issue, and contact email or whatsapp, our team will contact you."
          name="issue_detail"
          rules={[{ required: true, message: "Please describe your issue and provide contact info" }]}
        >
          <Input.TextArea rows={4} placeholder="Describe the issue and leave your Email/WhatsApp..." />
        </Form.Item>
      ),
    },
    {
      id: "category",
      title: "Creator Category",
      fields: ["category"],
      content: (
        <Form.Item
          label="What's your creator category? (Select all that apply)"
          name="category"
          rules={[{ required: true, message: "Please select at least one category" }]}
        >
          <Checkbox.Group style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div className="survey-checkbox-option-wrapper">
              <Checkbox className="survey-checkbox-option" value="online_store">Online Store</Checkbox>
              <Checkbox className="survey-checkbox-option" value="offline_store">Offline Store</Checkbox>
              <Checkbox className="survey-checkbox-option" value="brand">Brand</Checkbox>
              <Checkbox className="survey-checkbox-option" value="affiliate">Affiliate Partner</Checkbox>
              <Checkbox className="survey-checkbox-option" value="influencer">Influencer</Checkbox>
              <Checkbox className="survey-checkbox-option" value="coaching">Coaching / Consulting</Checkbox>
              <Checkbox className="survey-checkbox-option" value="digital_marketing">Digital Marketing</Checkbox>
              <Checkbox className="survey-checkbox-option" value="service_company">Service Company</Checkbox>
              <Checkbox className="survey-checkbox-option" value="real_estate">Real Estate / High-Ticket Sales</Checkbox>
            </div>
          </Checkbox.Group>
        </Form.Item>
      ),
    },
    {
      id: "features",
      title: "Upcoming Features",
      fields: selectedFeatures.includes("others") ? ["features", "other_feature"] : ["features"],
      content: (
        <>
          <Alert
            message="🚀 Big Update!"
            description="IOS and Android App (Launching Jan 2026)"
            type="info"
            showIcon
            style={{ marginBottom: 16 }}
          />
          <Form.Item
            label="What features are you waiting for? (Select all that apply)"
            name="features"
            rules={[{ required: true, message: "Please select at least one feature" }]}
          >
            <Checkbox.Group
              onChange={(vals) => setSelectedFeatures(vals)}
              style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '12px' }}
            >
              <div className="survey-checkbox-option-wrapper">
                <Checkbox className="survey-checkbox-option" value="collab_posts">Collab posts (Automate collab posts and track leads)</Checkbox>
                <Checkbox className="survey-checkbox-option" value="link_in_bio">Link in Bio</Checkbox>
                <Checkbox className="survey-checkbox-option" value="tiktok">Tiktok Automation</Checkbox>
                <Checkbox className="survey-checkbox-option" value="team_access">Team Access</Checkbox>
                <Checkbox className="survey-checkbox-option" value="multi_account">Multi Account Support</Checkbox>
                <Checkbox className="survey-checkbox-option" value="rerun">Re-run Automation</Checkbox>
                <Checkbox className="survey-checkbox-option" value="whatsapp">Whatsapp Automation</Checkbox>
                <Checkbox className="survey-checkbox-option" value="ai_automation">Instagram AI Automation (AI Answers to enquiries)</Checkbox>
                <Checkbox className="survey-checkbox-option" value="others">Others (Please Specify)</Checkbox>
              </div>
            </Checkbox.Group>
          </Form.Item>
          {selectedFeatures.includes("others") && (
            <Form.Item
              name="other_feature"
              rules={[{ required: true, message: "Please specify your feature request" }]}
              style={{ marginTop: 12 }}
            >
              <Input placeholder="Tell us what you're looking for..." />
            </Form.Item>
          )}
        </>
      ),
    },
  ];

  if (wantsAI) {
    steps.push({
      id: "ai_usecase",
      title: "Instagram AI Use Case",
      fields: ["ai_usecase_detail"],
      content: (
        <>
          <Form.Item
            label="Tell us more! What's your detailed use case for AI on your Instagram?"
            name="ai_usecase_detail"
            rules={[{ required: true, message: "Please describe your AI use case" }]}
          >
            <Input.TextArea rows={4} placeholder="e.g. Automated product recommendations, lead qualification, etc..." />
          </Form.Item>
          <div style={{ marginTop: 12, textAlign: "center", border: "1px solid #d9d9d9", borderRadius: 8, padding: 16, backgroundColor: "#f9f6ff" }}>
            <p style={{ marginBottom: 12, fontWeight: 500 }}>Want a custom AI solution for your account?</p>
            <Button
              type="primary"
              onClick={() => window.open("https://calendly.com/sanjaykhanssk/instantdm-ai", "_blank")}
            >
              Schedule free call with our AI team
            </Button>
          </div>
        </>
      ),
    });
  }

  useEffect(() => {
    if (current >= steps.length) {
      setCurrent(steps.length - 1);
    }
  }, [steps.length, current]);

  useEffect(() => {
    checkSurvey();
    async function checkSurvey() {
      if (!userData?.user_id) return;

      const docRef = doc(fireDB, survery_collection, userData?.user_id);
      const docSnap = await getDoc(docRef);
      if (PlanData?.plan_credits != "unlimited") {
        return
      }
      if (docSnap.exists()) {
        const data = docSnap.data();
        if (data.completed) {
          setOpen(false);
          return;
        }
        if (data.remindUntil && data.remindUntil.toDate() > new Date()) {
          setOpen(false);
          return;
        }
        setOpen(true);
      } else {
        setOpen(true);
      }
    }
  }, [userData?.user_id]);

  const handleSurveySubmit = async () => {
    const values = form.getFieldsValue(true)
    const docRef = doc(fireDB, survery_collection, userData?.user_id);
    await setDoc(docRef, {
      completed: true,
      answers: values,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      timestamp: new Date()
    });
    setOpen(false);
    setThankYou(true);
  };

  const next = async () => {
    try {
      const step = steps[current];
      if (step.fields) {
        await form.validateFields(step.fields);
      }
      setCurrent((c) => c + 1);
    } catch (err) {
      console.log("Validation failed:", err);
    }
  };

  return (
    <div>
      <Modal
        open={open}
        footer={null}
        closable={false}
        maskClosable={false}
        centered
        width={600}
        title="InstantDM Survey"
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSurveySubmit}
          preserve={true}
          className="survey-form"
        >
          <div style={{ marginTop: 24 }}>{steps[current] ? steps[current].content : null}</div>

          <div style={{ marginTop: 24, textAlign: "right" }}>
            {current > 0 && (
              <Button style={{ marginRight: 8 }} onClick={() => setCurrent(current - 1)}>
                Previous
              </Button>
            )}
            {steps[current] && current < steps.length - 1 && (
              <Button type="primary" onClick={next}>
                Next
              </Button>
            )}
            {steps[current] && current === steps.length - 1 && (
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            )}
          </div>
        </Form>
      </Modal>
      <Modal
        open={thankYou}
        footer={null}
        centered
        closable={false}
        title="Thank you 🎉"
      >
        {["perfect", "good"].includes(selectedRating?.toLowerCase()) ? (
          <>
            <p>We appreciate your feedback! Would you like to share your thoughts publicly? Here are a few things you could rate us on:</p>
            <ul style={{ textAlign: "left", marginBottom: 20, paddingLeft: 20 }}>
              <li>✨ Ease of use — was InstantDM simple to get started with?</li>
              <li>⚡ Features — do the automations cover your needs?</li>
              <li>💬 Support — did you feel supported along the way?</li>
              <li>💰 Value for money — do you feel InstantDM is worth the price?</li>
              <li>🌟 Overall experience — your honest impression</li>
            </ul>
            <Button
              type="primary"
              block
              onClick={() => window.open("https://www.trustpilot.com/review/instantdm.com")}
            >
              Rate us on Trustpilot
            </Button>
          </>
        ) : (
          <p style={{ textAlign: 'center', fontSize: '16px', margin: '20px 0' }}>
            We appreciate your honest feedback. It helps us improve InstantDM for everyone!
          </p>
        )}
        <Button
          color="primary"
          variant="outline"
          block
          onClick={() => setThankYou(false)}
          style={{ marginTop: '10px' }}
        >
          Close
        </Button>
      </Modal>
    </div>
  );
}


function HomeV2() {

  const [searchParams] = useSearchParams();
  let default_tab = searchParams.get("tab");
  default_tab = default_tab || "1"

  const navigate = useNavigate();
  const [loading, setLoading] = useState()
  const [data, setData] = useState()
  const { Meta } = Card;
  const [loadingAutomated, setLoadingAutomated] = useState()
  const [dataAutomated, setDataAutomated] = useState({ data: undefined })

  const [dataAutomatedFormated, setDataAutomatedFormated] = useState({})
  const [loadMore, setLoadMore] = useState(false)

  const [oldData, setOldData] = useState([])
  const [messageApi, contextHolder] = message.useMessage();

  const [postsError, setPostsError] = useState(undefined)

  const [totalCredits, setTotalCredits] = useState()

  let user_tz = Intl.DateTimeFormat().resolvedOptions().timeZone

  const [userUsage, setUserUsage] = useState({ "monthly_count": "" })
  const [accountViral, setAccountViral] = useState({})
  const [loadingUserUsage, setLoadingUserUsage] = useState(true)

  const [selectedCategory, setSelectedCategory] = useState('posts')

  const [showPlanModal, setShowPlanModal] = useState(false)

  const [statusError, setStatusError] = useState(false)

  const [trailActive, setTrailActive] = useState(8)

  const [filterPosts, setFilterPosts] = useState("all")



  const [postsLimitReached, setPostsLimitReached] = useState()
  const [postsAutomationLimit, setPostsAutomationLimit] = useState("Unlimitied")


  const [allowMoreAutomation, setAllowMoreAutomation] = useState(true)

  const [nextPostsLimitReached, setNextPostsLimitReached] = useState()
  const [nextPostsAutomationLimit, setNextPostsAutomationLimit] = useState(
    AccessOrNot(
      "next_post_automation",
      true,
      0,
      true)?.limit || "Unlimited"
  )

  useEffect(() => {
    if (nextPostsAutomationLimit == "Unlimited") {
      setNextPostsAutomationLimit(100)
      return
    }

  }, [nextPostsAutomationLimit])

  useEffect(() => {
    if (data?.posts_lists?.data) {
      setNextPostsLimitReached(data?.posts_lists?.data?.length)

    }

  }, [data])



  useEffect(() => {
    console.log("-=-=-=-=-postsLimitReached", postsLimitReached, postsAutomationLimit)
    if (postsLimitReached == undefined || postsAutomationLimit == "Unlimited") {
      return
    }
    if (postsLimitReached >= postsAutomationLimit) {
      setAllowMoreAutomation(false)
      messageApi.open({
        type: 'error',
        content: `You have reached your monthly limit of ${postsAutomationLimit} automations. Please upgrade your plan to continue.`,
        duration: 15,
        key: 3
      })
    }

  }, [postsLimitReached])

  useEffect(() => {

    setPostsLimitReached(Object.values(dataAutomatedFormated).filter(v => v === true).length)

  }, [dataAutomatedFormated])


  useEffect(() => {

    if (!filterPosts || filterPosts == "all") {
      return
    }

  }, [filterPosts])

  useEffect(() => {
    const token = localStorage.getItem("token")
    if (token == undefined) {

      navigate("/signup")
    }

    setLoadMore(true)
  }, [])

  useEffect(() => {
    if (postsError != undefined) {
      messageApi.open({
        type: 'error',
        content: postsError,
        duration: 15,
        key: 2
      })
    }
  }, [postsError])

  useEffect(() => {


    if (loadingUserUsage == true) {
      return
    }

    setAccountViral({ "reason_notify": userUsage?.automation_setting?.reason_notify || {} })
    setUserUsage({ "monthly_count": userUsage?.data?.monthly_count })

  }, [loadingUserUsage])

  const [userPlan, setUserPlan] = useState()
  const [userPlanLoading, setUserPlanLoading] = useState(true)

  useEffect(() => {

    let tempData = {}
    if (dataAutomated["data"] == undefined) {
      return
    }

    dataAutomated["data"].map((item) => {
      if (item?.flow_editor == true) {
        tempData[item.post_id] = "flow_editor"

      }
      else {
        tempData[item.post_id] = item.automated_segment.length > 0 ? true : false
      }

    })

    setDataAutomatedFormated(tempData)
    let apiURL = `ig-usage-stat?tz=${user_tz}`
    callAPI({ url: apiURL, method: "GET", loadingState: setLoadingUserUsage, dataState: setUserUsage })

    let apiURL2 = `user_plan`
    callAPI({ url: apiURL2, method: "GET", loadingState: setUserPlanLoading, dataState: setUserPlan })



  }, [dataAutomated])


  useEffect(() => {

    if (userPlan == undefined) {
      return
    }
    if (userPlan?.data == undefined) {
      return
    }
    if (userPlan?.data != undefined) {
      let copy_data = { ...userPlan }

      let credit = Number(copy_data?.data?.plan_credits) + Number(copy_data?.data?.topup_credit)

      setTotalCredits(credit)


      let temp_plan_id = "428337"

      const date1Obj = new Date(userPlan.data.account_created);

      const date2Obj = new Date();

      const differenceInTime = date2Obj.getTime() - date1Obj.getTime();
      let differenceInDays = Math.floor(differenceInTime / (1000 * 3600 * 24));

      let current_plan_id = userPlan.data.plan_details.id



      if (differenceInDays < 8) {

        localStorage.setItem("og_planID", current_plan_id)
        current_plan_id = current_plan_id == "free" ? temp_plan_id : current_plan_id

        setTrailActive(differenceInDays)

      }
      localStorage.setItem("planid", current_plan_id)

      let posts_automation = AccessOrNot(
        "posts_automation",
        true,
        0,
        true)?.limit || "Unlimited"
      console.log("-=-=-=-=-=-posts_automation", posts_automation)
      setPostsAutomationLimit(posts_automation);

      localStorage.setItem("founding_user", userPlan.data.founding_user)
      setUserPlan({ ...userPlan.data })

      return
    }

  }, [userPlan])

  useEffect(() => {
    messageApi.destroy(1)

    if (data != undefined && oldData.length < 1) {
      // On every inital load
      if (data.fb_api != undefined) { localStorage.setItem("fb_api", data.fb_api) }
      if (data.ig_api != undefined) { localStorage.setItem("ig_api", data.ig_api) }
    }

    if (oldData.length < 1 || data == undefined) {
      return
    }

    if (data?.code != 200) {
      setStatusError(true)
      return
    }
    if (data?.code == 200) {
      setStatusError(false)
    }

    let oldDataTemp = [...oldData]
    setOldData([])

    // console.log("=====DATATATA=====", data)
    if (data?.posts_lists?.error != undefined) {
      setPostsError(data.posts_lists.error.message)
    }

    if (data.posts_lists.data != undefined) {

      setData({ ...data, posts_lists: { ...data.posts_lists, data: [...oldDataTemp, ...data.posts_lists.data] } })
    }



    setStatusError(false)


  }, [data])

  useEffect(() => {
    if (loading == true) {
      return
    }
    if (loadMore == false) {
      return
    }
    // messageApi.open({
    //   type: 'loading',
    //   content: 'Loading your posts',
    //   duration: 0,
    //   key: 1
    // });

    let apiURL = ""

    if (selectedCategory == "posts") {
      apiURL = "ig-posts"
    }
    if (selectedCategory == "stories") {
      apiURL = "ig-stories"
    }

    if (selectedCategory == "next-post") {
      apiURL = "next-post"
    }
    // let old_data = []

    // console.log("API going to call")
    if (data?.posts_lists?.paging?.cursors?.after) {
      apiURL += `?after=${data?.posts_lists?.paging?.cursors?.after}`
      if (data.posts_lists.data != undefined) {
        setOldData([...data.posts_lists.data])
      }

    }

    callAPI({ url: apiURL, method: "GET", loadingState: setLoading, dataState: setData })

    if (dataAutomated.data == undefined) {
      let apiAutmatedURL = `automate-post`
      callAPI({ url: apiAutmatedURL, method: "GET", loadingState: setLoadingAutomated, dataState: setDataAutomated })
    }


    setLoadMore(false)


  }, [loadMore])

  useEffect(() => {

    setData()
    setLoadMore(loadMore == undefined ? true : undefined)


  }, [selectedCategory])


  const [paymentLinkData, setPaymentLinkData] = useState()
  const [paymentLinkLoading, setPaymentLinkLoading] = useState()

  const [showINR, setShowINR] = useState((user_tz == "Asia/Kolkata" || user_tz == "Asia/Calcutta") ? true : false)

  const [showWaitingPaymentUpdate, setShowWaitingPaymentUpdate] = useState(false)
  const [showWaitingPaymentFailed, setShowWaitingPaymentFailed] = useState(false)

  const [showWhatsNew, setShowWhatsNew] = useState(false)
  const [showTutorialModal, setShowTutorialModal] = useState(false)


  let release_id = "release_30122024"

  useEffect(() => {


    if (paymentLinkData?.open_url) {

      window.location.href = paymentLinkData?.payment_url
      return

    }

    if (paymentLinkData?.payment_url == undefined) {
      return
    }

    messageApi.destroy("payment-process")


    if (!showINR && window.LemonSqueezy) {
      const checkoutUrl = paymentLinkData.payment_url
      window.LemonSqueezy.Url.Open(checkoutUrl);
    }

    if (showINR && window.Razorpay) {

      try {

        const options = {
          key: "rzp_live_JtjGCHjkESNzIZ",
          name: "InstantDM",
          description: "Affordable Comment to DM automation tool",
          subscription_id: paymentLinkData.rzpy_sub_id, // Order ID from your server (generated by your backend)
          handler: function (response) {
            setShowPlanModal(false)
            setShowWaitingPaymentUpdate(true)

            message.success("Payment completed, Please wait while we're verfiying!")
            let user_detail = JSON.parse(localStorage.getItem("userData"))
            let igid = localStorage.getItem("ig_id")

            const BOT_TOKEN = "7109212238:AAEsaFubA66rs0Ib6rgn5K2amKO9rnOkUv0";
            const CHAT_ID = '776956029';
            const url = `https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`;
            let tele_message = `[SUBSCRIBED PLAN] - user ${user_detail.emailid}  - Subscribed for  , IG ID = ${igid} , user id = ${user_detail.user_id}`
            let data = {
              chat_id: CHAT_ID,
              text: tele_message
            };


            fetch(url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(data)
            })
              .then(response => response.json())
              .then(data => {
                console.log('Message sent successfully:', data);
              })
              .catch(error => {
                console.error('Error sending message:', error);
              });
            setPaymentLinkData({})




          },
          error: function (response) {
            setShowPlanModal(false)
            setShowWaitingPaymentFailed(true)
            setPaymentLinkData({})
            // alert("Payment Failed: " + response.error.description);
          },
          prefill: {
            name: paymentLinkData.customer_name,
            email: paymentLinkData.customer_email,
          },
          "notes": paymentLinkData.notes != undefined ? { ...paymentLinkData.notes } : {},
          theme: {
            color: "#1677ff",
          },
          display: {
            handler: function () {
              return {
                "offers": [
                  {
                    "type": "discount",
                    "description": "10% discount on first purchase",
                    "amount": 100
                  },
                  {
                    "type": "coupon",
                    "description": "Rs. 100 off on total bill",
                    "code": "INSTANT10"
                  }
                ]
              }
            }
          },
        };

        const razorpayInstance = new window.Razorpay(options);
        razorpayInstance.open();

      } catch (error) {
        alert("Error loading Razorpay: " + error.message);
      } finally {
        // setLoading(false);
      }

    }

    else {
      message.error("Please try again later...")
    }



  }, [paymentLinkData])

  function planContent() {

    if (userPlan == undefined) {
      return <p>Loading</p>
    }
    return (
      <div>

        <Statistic
          title="Plan credits"
          value={userPlan?.plan_credits}
          // precision={2}
          valueStyle={{
            color: 'black',
            fontWeight: '600'
          }} />

        <Statistic
          title="Topup credits"
          value={userPlan?.topup_credit}
          // precision={2}
          valueStyle={{
            color: 'black',
            fontWeight: '600'
          }} />

        {userPlan?.plan_details?.id == "free" && <Button type="primary" style={{ marginTop: '10px' }} onClick={() => { userPlan?.plan_details?.id == "free" && setShowPlanModal(true) }}>
          Upgrade to paid plan
        </Button>
        }

        {/* <Button type="primary" style={{marginTop:'10px'}} onClick={() => {userPlan?.plan_details?.id == "free" ? setShowPlanModal(true) : createPaymentLink("topup",messageApi, setPaymentLinkLoading, setPaymentLinkData) }}>
              { userPlan?.plan_details?.id == "free" ? "Upgrade to paid plan" : "Buy more credits"}
            </Button> */}

      </div>
    )
  }
  const [previewImage, setPreviewImage] = useState(null);
  const [previewOpen, setPreviewOpen] = useState(false);


  const UsageCard = ({
    title,
    description,
    buttonText = "Learn More",
    onClick,
    images = [],
    features = [],
    link,
    ignoreText,
    isNew
  }) => {
    return (
      <div
        style={{
          marginRight: "10px",
          display: "flex",
          flexDirection: "column",
          // maxWidth:"400px",
          // minWidth: "60%",

        }}
        className="usage-content white-bg-border reuse-usage"
      >
        <Flex
          align="center"
          justify="space-between"
          wrap
          style={{ marginBottom: "10px", width: "100%" }}
        >
          <h3 style={{ margin: 0, flex: 1, fontWeight: "500" }}>{isNew && <Tag color="green">New</Tag>} {title}</h3>
          {/* <Button className="desktop" onClick={onClick} color="purple" variant="solid">
                {buttonText}
              </Button> */}
        </Flex>

        <p>{description}</p>

        {/* Image Carousel */}
        {images.length > 0 && (
          <Carousel autoplay dots className="usage-carousel" style={{ marginTop: 16 }}>
            {images.map((img, index) => (
              <div key={index}>
                <img
                  src={img}
                  alt={`slide-${index}`}
                  style={{ width: "100%", height: "200px", objectFit: "cover", borderRadius: "12px" }}
                />
              </div>
            ))}
          </Carousel>
        )}

        {/* Feature List */}
        {features.length > 0 && (
          <List
            size="small"
            style={{ marginTop: 16 }}
            dataSource={features}
            renderItem={(item) => (
              <List.Item style={{ paddingLeft: 0 }}>
                <span>✅</span>
                <span style={{ marginLeft: 8 }}>{item}</span>
              </List.Item>
            )}
          />
        )}

        {/* Mobile Button */}
        {!link ? <Button
          // className="mobile"
          onClick={onClick}
          color="purple"
          variant="solid"
          style={{ marginTop: 16 }}
        >
          {buttonText}
        </Button> : <Button
          // className="mobile"
          href={`${link}`}
          color="purple"
          variant="solid"
          style={{ marginTop: 16 }}
        >
          {buttonText}
        </Button>}

        {
          ignoreText && <p style={{ fontSize: "12px", opacity: ".5", textAlign: "center" }}>{ignoreText}</p>
        }

      </div>
    );
  };

  const AndroidAppCard = () => {
    return (
      <div
        style={{
          marginRight: "10px",
          display: "flex",
          flexDirection: "column",
        }}
        className="usage-content white-bg-border reuse-usage"
      >
        <Flex
          align="center"
          justify="space-between"
          wrap
          style={{ marginBottom: "10px", width: "100%" }}
        >
          <h3 style={{ margin: 0, flex: 1, fontWeight: "500" }}>
            <Tag color="#108ee9">New</Tag> Download Mobile App
          </h3>
        </Flex>

        <p style={{ marginBottom: 16 }}>
          Get InstantDM app to manage your DMs/Automation on the go!
        </p>

        <div style={{ display: 'flex', gap: '10px', flexDirection: 'column' }}>

          <Button
            type="primary"
            block
            href="https://apps.apple.com/in/app/insta-dm-app-instantdm/id6756658913"
            target="_blank"
            icon={<AppleOutlined />}
            style={{ background: 'black', borderColor: 'black' }}
          >
            Open App Store
          </Button>

          <Button
            type="primary"
            block
            href="https://play.google.com/store/apps/details?id=com.replbetter.instantdm"
            target="_blank"
            icon={<AndroidOutlined />}
            style={{ background: 'black', borderColor: 'black', color: 'white' }}
          >
            Open Play Store
          </Button>

        </div>
      </div>
    );
  };

  // console.log("========CREDIT=====" , totalCredits)
  return (
    <div className="page-layout">
      {contextHolder}

      <Sider />
      <div className="page-content">

        {/* Pongal Sankranti Festival Banner */}
        <PongalSankrantiBanner onCTAClick={() => setShowPlanModal(true)} />

        {(userPlan?.sub_status != undefined && userPlan?.sub_status != "active" && userPlan?.plan_details?.id != "free") && <Alert
          message="Subscription Expired"
          description="Ohho no, you're supscription expired, please renew to continue"
          type="error"
          style={{ marginBottom: '10px', marginTop: '10px' }}
          action={
            <Button size="large" type="primary" onClick={() => { setShowPlanModal(true) }}>
              Renew Subscription
            </Button>
          }
          closable
          showIcon />
        }
        {(trailActive < 8 && userPlan?.plan_details?.id == "free") && <Alert
          message="7 Days Free Trail"
          description={`You're currently on 7 days free trail, and your free trail will exipre in ${7 - trailActive} days.`}

          style={{ marginBottom: '10px', marginTop: '10px' }}
          action={
            <div className="free-alert-btns">
              <Button style={{ marginRight: "10px" }} size="large" color="default" variant="solid" href="https://awake-morning-bb9.notion.site/InstantDM-Premium-access-Limited-Time-Offer-21e7409f565480d6b261ff11a62ada7c?source=copy_link">
                Extend Free Trail
              </Button>

              <Button size="large" type="primary" onClick={() => { setShowPlanModal(true) }}>
                Show Plans
              </Button>
            </div>
          }
          closable
          showIcon />
        }
        {(trailActive >= 8 && totalCredits != 0 && userPlan?.plan_details?.id == "free") && <Alert
          message="Free Plan"
          description="You're currently on free plan, click here to upgrade your plan."
          type="error"
          style={{ marginBottom: '10px', marginTop: '10px' }}
          action={
            <div className="free-alert-btns">
              <Button style={{ marginRight: "10px" }} size="large" color="default" variant="solid" href="https://awake-morning-bb9.notion.site/InstantDM-Premium-access-Limited-Time-Offer-21e7409f565480d6b261ff11a62ada7c?source=copy_link">
                Extend Free Trail
              </Button>

              <Button size="large" type="primary" onClick={() => { setShowPlanModal(true) }}>
                Show Plans
              </Button>
            </div>
          }
          closable
          showIcon />
        }
        {(totalCredits < 1 && userPlan?.plan_details?.id == "free") && <Alert
          message="Automation Stoped!"
          description="You have reached your monthly free usage limit. To continue using our automation services, please consider upgrading to a paid plan."
          type="error"
          style={{ marginBottom: '10px', marginTop: '10px' }}
          action={
            <div className="free-alert-btns">
              <Button style={{ marginRight: "10px" }} target="_blank" size="large" color="default" variant="solid" href="https://awake-morning-bb9.notion.site/InstantDM-Premium-access-Limited-Time-Offer-21e7409f565480d6b261ff11a62ada7c?source=copy_link">
                Extend Free Trail
              </Button>

              <Button size="large" type="primary" onClick={() => { setShowPlanModal(true) }}>
                Show Plans
              </Button>
            </div>
          }
          closable
          showIcon />
        }
        {(totalCredits < 1 && userPlan?.plan_details?.id != "free") && <Alert
          message="Credits Over, Automation Stoped!"
          description="Switch to different plan to continue.."
          type="error"
          style={{ marginBottom: '10px', marginTop: '10px' }}
          action={
            <Button size="large" type="primary" onClick={() => { setShowPlanModal(true) }}>
              Show Plans
            </Button>
          }
          closable
          showIcon />
        }
        <div className="home-sec-1" style={{ height: "100vh", overflowY: "scroll" }}>

          <Flex wrap="nowrap" style={{ overflowX: "scroll", overflowY: "scroll" }}>
            {
              (accountViral?.reason_notify?.title != undefined && !accountViral?.reason_notify?.title.includes("Message from Instagram")) &&
              <UsageCard title={accountViral?.reason_notify?.title} description={accountViral?.reason_notify?.message} />}


            <div className="col-desktop-row-mobile" vertical>
              <AndroidAppCard />

              {/* <UsageCard
                title={"Early access to android app, limited seats only"}
                description={"Get early access to our Android app and manage your DMs on the go!"}
                buttonText="Get Early Access"
                isNew={true}
                onClick={() => setShowAndroidPopup(true)}
              /> */}

              {/* <UsageCard title={"InstantDM is Public, Suggest Features."} description={"✨ Got an idea to make InstantDM better? We’d love to hear it! \n 💡 Submit your feature requests and help shape what we build next."} buttonText="Suggest new feature" link="/shopify" /> */}
              {/* {!localStorage.getItem("shopify_store") && <UsageCard title={"InstantDM ❤️ Shopify "} description={"Boost your sales with automated follow ups, upsells and grow your community for organic sales or just share link with one click. Don’t miss out on sales — connect shopify now to start making more from your Instagram DMs."} buttonText="Watch Video" link="/shopify" />} */}

              {/* {!localStorage.getItem("shopify_store") && <UsageCard title={"🔥 Sell online with zero platform fee"} description={"Sell anything and everything online using Instant Mini with zero platform and fast withdrwal! 🙌"} buttonText="Open Mini" link="/digital-products" />} */}
              {/* <UsageCard title={"❤️ Love InstantDM"} description={"Share your feedback. 🌟 Help others discover InstantDM by leaving a quick review on G2. Your support means the world to us! 🙌"} buttonText="Submit Feedback" link="https://www.g2.com/products/instantdm/reviews" /> */}
              {/* <UsageCard title={"🤑 Earn with InstantDM"} description={"Earn referral commission of upto 50% for every refferal with your coupon code. Get your link, Make videos, Earn money🙌"} buttonText="Know More" link="/referral-dashboard" /> */}
              {/* <UsageCard title={"✨ FB Automation is Live"} description={"Facebook Automation is live now, you can start automating facebook along with your instagram posts/reels."} buttonText="Automate FB" link="/fb"/> */}
              {/* <UsageCard title={"BUG FIX - Schedule with AutoDM bug fixed"} description={"We fixed the bug where the schedule with AutoDM was not working for few users."} buttonText="Learn More" link="/later" /> */}

              {/* <UsageCard title={"How To Automate? Watch Video."}  description={"Step by Step Tutorial - Watch Video Tutorial on how to automate your Instagram and Facebook using InstantDM Platform."} buttonText="Watch Video" onClick={() => setShowTutorialModal(true)} /> */}

            </div>

            {postsAutomationLimit != "Unlimited" &&
              <div className="usage-content desktop white-bg-border" style={{ display: "flex", flexDirection: "column", marginRight: "10px", width: "80%", maxWidth: "400px" }}>

                {postsAutomationLimit != "Unlimited" && <Col style={{ marginTop: "-10px", width: "350px", overflowX: "scroll" }} className="hide-scrollbar">

                  <Flex align="center" justify="space-between" wrap style={{ marginBottom: "10px", width: "100%" }}>
                    <h3 style={{ flex: 1, opacity: ".5", fontWeight: "500" }}>Posts Automated</h3>
                    <Button onClick={() => setShowPlanModal(true)} color="purple" variant="solid">Upgrade Plan</Button>
                  </Flex>
                  <Progress
                    percent={
                      (
                        postsLimitReached /
                        postsAutomationLimit *
                        100
                      ) || 0
                    }
                    steps={
                      postsAutomationLimit
                    }
                    strokeColor={
                      (() => {

                        const percent = (postsLimitReached / postsAutomationLimit) * 100;
                        if (percent >= 100) return "#ff4d4f"; // red
                        if (percent >= 60) return "#faad14"; // orange
                        return "#4f8cff"; // blue
                      })()
                    }
                    format={() => {

                      const left = Math.max(postsAutomationLimit - postsLimitReached, 0);
                      const percent = (postsLimitReached / postsAutomationLimit) * 100;
                      let color = "#4f8cff";
                      if (percent >= 100) color = "#ff4d4f";
                      else if (percent >= 60) color = "#faad14";
                      return (
                        <span style={{ color, fontWeight: 600 }}>
                          {left} remaining
                        </span>
                      );
                    }}
                  />

                </Col>}


              </div>}

            {postsAutomationLimit != "Unlimited" && <div className="usage-content mobile white-bg-border" style={{ display: "flex", flexDirection: "column", marginRight: "10px", width: "80%", maxWidth: "400px" }}>

              {/* <Col>

          <Statistic
            title="Monthly Automated"
            value={userUsage.monthly_count || "NA"}
            // precision={2}
            valueStyle={{
              color: 'black',
              fontWeight: '600'
            }} />

          </Col>
          
          <Col>
          <Statistic title="Available credits" value={userPlan?.plan_credits != "unlimited" ? totalCredits : userPlan?.plan_credits} />
          </Col>
           */}

              {postsAutomationLimit != "Unlimited" && <Col style={{ marginTop: "-10px", width: "350px", overflowX: "scroll" }} className="hide-scrollbar">

                <Flex align="center" justify="space-between" wrap style={{ marginBottom: "10px", width: "100%" }}>
                  <h3 style={{ flex: 1, opacity: ".5", fontWeight: "500" }}>Posts Automated</h3>
                  <Button onClick={() => setShowPlanModal(true)} color="purple" variant="solid">Upgrade Plan</Button>
                </Flex>
                <Progress
                  percent={
                    (
                      postsLimitReached /
                      postsAutomationLimit *
                      100
                    ) || 0
                  }
                  steps={
                    postsAutomationLimit
                  }
                  strokeColor={
                    (() => {

                      const percent = (postsLimitReached / postsAutomationLimit) * 100;
                      if (percent >= 100) return "#ff4d4f"; // red
                      if (percent >= 60) return "#faad14"; // orange
                      return "#4f8cff"; // blue
                    })()
                  }
                  format={() => {

                    const left = Math.max(postsAutomationLimit - postsLimitReached, 0);
                    const percent = (postsLimitReached / postsAutomationLimit) * 100;
                    let color = "#4f8cff";
                    if (percent >= 100) color = "#ff4d4f";
                    else if (percent >= 60) color = "#faad14";
                    return (
                      <span style={{ color, fontWeight: 600 }}>
                        {left} remaining
                      </span>
                    );
                  }}
                />
                {/* <Progress  type="circle" percent={ (AccessOrNot("posts_automation" , true, Object.values(dataAutomatedFormated).filter(v => v === true).length, true )?.current_usage / AccessOrNot("posts_automation" , true, Object.values(dataAutomatedFormated).filter(v => v === true).length, true )?.limit) *100 } format={ percent => `${AccessOrNot("posts_automation" , true, Object.values(dataAutomatedFormated).filter(v => v === true).length, true )?.current_usage} / ${AccessOrNot("posts_automation" , true, Object.values(dataAutomatedFormated).filter(v => v === true).length, true )?.limit}`} /> */}

              </Col>}


            </div>}

          </Flex>


          <NewYearSaleBanner enableDismiss={true} enableScratch={true} onBuyNowClick={() => setShowPlanModal(true)} />


          <Tabs defaultActiveKey={default_tab} style={{ width: "100%", }} items={[

            {
              "key": "1",
              "label": <p>Quick <span className="desktop">Automation</span></p>,
              children: <IGPosts nextPostsAutomationLimit={nextPostsAutomationLimit} allowMoreAutomation={allowMoreAutomation} setShowPlanModal={setShowPlanModal} hideGlobalAutomation={true} />
            },

            {
              "key": "2",
              "label": <p>Quick Global <span className="desktop">Automation</span> <Tag color="Purple">New</Tag></p>,
              children: <IGPosts nextPostsAutomationLimit={nextPostsAutomationLimit} allowMoreAutomation={allowMoreAutomation} setShowPlanModal={setShowPlanModal} showOnlyGlobalAutomation={true} />
            },

            {
              "key": "3",
              "label": <p>DM & Flows <span className="desktop">Automation</span></p>,
              "children": <AutomationList />
            },

          ]} />
          {/* <WhatsNew/> */}




        </div>

      </div>




      {/* <a className="mobile" target="_blank" href="https://instagram.com/instant.dm">
      <FloatButton style={{ padding:"0px",bottom:"100px"}} icon={<MessageOutlined />} >
      </FloatButton>
      </a>

      <a className="desktop" target="_blank" href="https://instagram.com/instant.dm">
      <FloatButton style={{  padding:"0px", bottom:"50px"}} icon={<MessageOutlined  />} >
      </FloatButton>
      </a> */}


      <Modal
        title="Plans"
        open={showPlanModal}
        onCancel={() => setShowPlanModal(false)}
        width='100%'
      // maxWidth='800px'
      >


        <ShowPlans messageApi={messageApi} setPaymentLinkLoading={setPaymentLinkLoading} setPaymentLinkData={setPaymentLinkData} currentPlan={localStorage.getItem("planid")} />
      </Modal>

      {/* Tutorial Modal */}
      <Modal
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <VideoCameraOutlined style={{ fontSize: '20px', color: '#1890ff' }} />
            <span>Video Tutorials</span>
          </div>
        }
        open={showTutorialModal}
        onCancel={() => setShowTutorialModal(false)}
        footer={null}
        width={1000}
        style={{ top: 20 }}
      >
        <div style={{ marginBottom: '16px' }}>
          <p style={{ color: '#666', fontSize: '14px' }}>
            Learn how to use InstantDM with our step-by-step video tutorials.
          </p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
          {[
            {
              title: "Getting Started with InstantDM - Quick Automation",
              description: "Learn the basics of setting up your first automation",
              videoId: "JrtbVS1oZ2Q",
            },
            {
              title: "Global Quick Automation Setup",
              description: "Set up comment-to-DM automation in minutes",
              videoId: "example2",
            },
            {
              title: "DM & Flow Editor Tutorial",
              description: "Build complex automations with the flow editor",
              videoId: "example3",
            },
            {
              title: "Facebook Automation",
              description: "Automate your Facebook posts and stories",
              videoId: "example4",
            },
            {
              title: "Shopify Integration",
              description: "Connect your Shopify store and automate sales",
              videoId: "example5",
            },
            {
              title: "Schedule with AutoDM",
              description: "Pro tips to maximize your automation results",
              videoId: "example6",
            },
          ].map((item, index) => (
            <div key={index} style={{ marginBottom: '16px' }}>
              <h3 style={{ fontSize: '16px', fontWeight: 600, marginBottom: '8px' }}>
                {item.title}
              </h3>
              <p style={{ fontSize: '14px', color: '#666', marginBottom: '12px' }}>
                {item.description}
              </p>
              <div style={{
                position: 'relative',
                paddingBottom: '56.25%',
                height: 0,
                overflow: 'hidden',
                borderRadius: '8px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
              }}>
                <iframe
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    border: 'none',
                    borderRadius: '8px'
                  }}
                  src={`https://www.youtube.com/embed/${item.videoId}`}
                  title={item.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                />
              </div>
            </div>
          ))}
        </div>

        <Divider />

        <div style={{ textAlign: 'center' }}>
          <p style={{ marginBottom: '12px', color: '#666' }}>
            Need more help? Check out our YouTube channel for more tutorials!
          </p>
          <Button
            type="primary"
            icon={<YoutubeOutlined />}
            size="large"
            href="https://www.youtube.com/@instantdm"
            target="_blank"
          >
            Visit YouTube Channel
          </Button>
        </div>
      </Modal>


      {userPlan?.plan_credits && <WelcomePopup PlanData={userPlan} />}


    </div>
  )

}
export default HomeV2;
